module.exports = __webpack_public_path__ + "assets/img/5_1183_big.fa0db8d5.jpg";